import axios from "axios";
import {paramsToFormData} from "./paramsToFormData";
import {Toast} from "antd-mobile";
import {useNavigate} from "react-router-dom";

import imageCompression from "browser-image-compression";

export const serviceUrl = '';

class ApiService{
  //获取人员列表
  static async getConfig(){
    let result: any=[];
    try{

      let ret = await axios.get(serviceUrl+"/api/setup/getConfig");
      result = ret.data;
    }catch (e){
      console.log('getConfig','请求失败')
      Toast.show({content: '操作失败'+e})
    }
    return result;
  }
  //获取人员列表
  static async getWarnList(data:any){
    let result: any=[];
    try{

      let ret = await axios.post(serviceUrl+"/api/warn/list",paramsToFormData(data));
      result = Retprocess(ret.data);
    }catch (e){
      console.log('getPeopleList','请求失败')
      Toast.show({content: '操作失败'+e})
    }
    return result;
  }

  //获取人员列表
  static async getWarnInfo(id: any){
    let result: any=[];
    try{

      let ret = await axios.post(serviceUrl+`/api/warn/info/${id}`);
      result = Retprocess(ret.data);
    }catch (e){
      console.log('getPeopleInfo','请求失败')
      Toast.show({content: '操作失败'+e})
    }
    return result;
  }
  static async setWarnInfo(data:any){
    let result: any=[];
    try{

      let ret = await axios.post(serviceUrl+"/api/warn/save",paramsToFormData(data));
      result = Retprocess(ret.data);
    }catch (e){
      console.log('setPeopleInfo','请求失败')
      Toast.show({content: '操作失败'+e})
    }
    return result;
  }

  static async getPosition(xy: any){
    let result: any=[];
    try{
      let ret = await axios.get(serviceUrl+`/api/position/getByXY/${xy}`);
      result = Retprocess(ret.data);
    }catch (e){
      console.log('getPosition','请求失败')
      Toast.show({content: '操作失败'+e})
    }
    return result;
  }

  //获取设备绑定状态
  static async getBindStatus(device_id: any){
    let result: any=[];
    try{
      let ret = await axios.get(serviceUrl+`/api/device/checkBind/${device_id}`);
      result = Retprocess(ret.data);
    }catch (e){
      console.log('login','请求失败')
      Toast.show({content: '操作失败'+e})
    }
    return result;
  }

  //保存设备绑定信息
  static async setBindInfo(data:any){
    let result: any=[];
    try{

      let ret = await axios.post(serviceUrl+"/api/device/savebind",paramsToFormData(data));
      result = Retprocess(ret.data);
    }catch (e){
      console.log('getPosition','请求失败')
      Toast.show({content: '操作失败'+e})
    }
    return result;
  }

  //获取人员列表
  static async getPeopleList(data:any){
    let result: any=[];
    try{

      let ret = await axios.post(serviceUrl+"/api/people/list",paramsToFormData(data));
      result = Retprocess(ret.data);
    }catch (e){
      console.log('getPeopleList','请求失败')
      Toast.show({content: '操作失败'+e})
    }
    return result;
  }

  //获取人员列表
  static async getPeopleInfo(id: any){
    let result: any=[];
    try{

      let ret = await axios.post(serviceUrl+`/api/people/info/${id}`);
      result = Retprocess(ret.data);
    }catch (e){
      console.log('getPeopleInfo','请求失败')
      Toast.show({content: '操作失败'+e})
    }
    return result;
  }
  static async setPeopleInfo(data:any){
    let result: any=[];
    try{

      let ret = await axios.post(serviceUrl+"/api/people/save",paramsToFormData(data));
      result = Retprocess(ret.data);
    }catch (e){
      console.log('setPeopleInfo','请求失败')
      Toast.show({content: '操作失败'+e})
    }
    return result;
  }

  //文件上传
  static async fileUpload(data:any){
    let result: any=[];

    const isJpgOrPng = data.file.type === "image/jpeg" || data.file.type === "image/png";
    if (isJpgOrPng) {
      try {
        const options = {
          maxWidthOrHeight: 1500,
          maxSizeMB: 0.2,
          useWebWorker: true,
          libURL: "https://unpkg.com/browser-image-compression@2.0.2/dist/browser-image-compression.js"
        };

        data.file = await imageCompression(data.file, options);
      } catch (error) {
        console.error("Error compressing image:", error);
      }
    }

    try{
      let ret = await axios.post(serviceUrl+"/api/file/upload",paramsToFormData(data),{
        headers: {
          'Content-Type': 'multipart/form-data', // 设置请求头为 multipart/form-data
        }
      });
      result = Retprocess(ret.data);
    }catch (e){
      console.log('fileUpload','请求失败')
      Toast.show({content: '操作失败'+e})
    }
    return result;
  }

  //文件删除
  static async deleteFile(data:any){
    let result: any=[];
    try{

      let ret = await axios.post(serviceUrl+"/api/file/delete",paramsToFormData(data));
      result = Retprocess(ret.data);
    }catch (e){
      console.log('getPosition','请求失败')
      Toast.show({content: '操作失败'+e})
    }
    return result;
  }
  static async getMyInfo(){
    let result: any=[];
    try{

      let ret = await axios.get(serviceUrl+`/api/user/my`);
      result = Retprocess(ret.data);
    }catch (e){
      console.log('getMyInfo','请求失败')
      Toast.show({content: '操作失败'+e})
    }
    return result;
  }

  //登录接口
  static async login(data:any){
    let result=undefined;
    try{

      const ret = await axios.post(serviceUrl+"/api/login/confirm",paramsToFormData(data));
      return ret.data;

    }catch (e){
      console.log('login','请求失败')
      Toast.show({content: '操作失败'+e})
    }
    return result;
  }
  static async logout() {
    const ret = await axios.get(serviceUrl+'/api/login/logout');

    return ret;
  }

  //登录接口
  static async bind(data:any){
    let result=undefined;
    try{

      const ret = await axios.post(serviceUrl+"/api/user/bind",paramsToFormData(data));
      return ret.data;

    }catch (e){
      console.log('bind','请求失败')
      Toast.show({content: '操作失败'+e})
    }
    return result;
  }
  static async ubind(){
    let result: any=[];
    try{

      let ret = await axios.get(serviceUrl+`/api/user/ubind`);
      result = Retprocess(ret.data);
    }catch (e){
      console.log('ubind','请求失败')
      Toast.show({content: '操作失败'+e})
    }
    return result;
  }

}
export default ApiService;

function Retprocess(obj: any,url='') {
  if (obj.code === 1) {//正常，不处理
  } else if (obj.code === 0) {
    alert(obj.message);//基础报错
    return;
  } else if (obj.code === 9) {
    const localtion = escape(window.location.href);
    window.location.href = '/api/wechat/getopenid?location_url='+localtion;
    //Toast.show("登录过期");
    //NavigationService.navigate('Login');
    return;
  } else if (obj.code < 10000) {
    //1万以内都是正常报错,由页面自行逻辑处理
  } else {
    throw new Error(obj.message);
  }
  return obj;
}
